import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import CustomisedModal from "components/Application/CustomisedModal";
import Select from "react-select";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";

import {
  getProductDetailListByProductCategoryIdRequest,
  updateProductDetailStatusByProductDetailIdRequest,
  addProductDetailRequest,
  updateProductDetailByProductDetailIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { toastrMessage } from "helpers/messageHelper";
import { makeProductDetailSelectField } from "store/ProductDetail/selector";
import { selectSortedProductCategories } from "store/Masters/ProductCategory/selector";
import { createStructuredSelector } from "reselect";
import SimpleReactValidator from "simple-react-validator";

class ProductDetailForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      productDetailData: productDetailDataInitialState(),
    };
    this.validator = new SimpleReactValidator();
  }

  resetForm = (closeModal) => {
    this.setState({
      productDetailData: productDetailDataInitialState(),
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.productDetailApiResponse &&
      this.props.productDetailApiResponse !== nextprops.productDetailApiResponse
    ) {
      if (nextprops.productDetailApiResponse.isSuccessResponse) {
        this.props.getProductDetailListByProductCategoryIdRequest(
          this.props.productCategoryId
        );
        toastrMessage(
          nextprops.productDetailApiResponse.responseMessage,
          SUCCESS
        );
        this.resetForm(true);
      } else if (!nextprops.productDetailApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.productDetailApiResponse.responseMessage,
          DANGER
        );
      }
    }

    if (this.props.productDetailRecord !== nextprops.productDetailRecord) {
      if (nextprops.productDetailRecord?.productDetailId) {
        this.setState({
          productDetailData: nextprops.productDetailRecord,
          operationType: UPDATE,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  formSubmit = (values) => {
    if (this.validator.allValid()) {
      this.setState({ productDetailData: values });
      if (this.state.operationType === UPDATE) {
        this.props.updateProductDetailByProductDetailIdRequest(
          values.productDetailId,
          values
        );
      } else {
        this.props.addProductDetailRequest(values);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="ProductDetail"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.productDetailData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Select Product Category</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          component={Select}
                          name="productCategoryId"
                          options={this.props.sortedProductCategoryList}
                          onChange={(opt, e) => {
                            setFieldValue("productCategoryId", opt.value);
                          }}
                          value={this.props.sortedProductCategoryList.filter(
                            (option) =>
                              option.value === values.productCategoryId
                          )}
                        ></Field>
                        {this.validator.message(
                          "productCategoryId",
                          values.productCategoryId,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="productName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "productName",
                          values.productName,
                          "required"
                        )}
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Description</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="productDesc"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "productDesc",
                          values.productDesc,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Sequence</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="productSeq"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Product Sequence",
                          values.productSeq,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productDetailApiResponse: makeProductDetailSelectField(
    "productDetailApiResponse"
  ),
  sortedProductCategoryList: selectSortedProductCategories(),
});

const withConnect = connect(mapStatetoProps, {
  getProductDetailListByProductCategoryIdRequest,
  updateProductDetailStatusByProductDetailIdRequest,
  addProductDetailRequest,
  updateProductDetailByProductDetailIdRequest,
});

export default compose(withConnect, withRouter)(ProductDetailForm);
//export default withRouter(withConnect)(Index);

function productDetailDataInitialState() {
  return {
    productName: "",
    productDesc: "",
    productCategoryId: "",
    productSeq: "",
  };
}
